var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgZircuit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 32,
    viewBox: "0 0 110 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2265_11071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.5215 20.0328L52.0164 11.497H45.6082V9.823H54.441V11.3295L47.9461 19.8657H54.5277V21.5393H45.5215V20.0328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3926 9.823H57.2978V11.5803H55.3926V9.823ZM55.4793 13.1706H57.2111V21.5393H55.4793V13.1706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.25 13.1709H59.7223L59.8956 13.9242H59.9822C60.2767 13.6061 60.5538 13.1709 61.6278 13.1709H63.1868V14.6774H61.8012C60.5889 14.6774 59.9827 15.2632 59.9827 16.4182V21.54H58.2509V13.1713L58.25 13.1709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4129 18.6098C71.136 19.8651 70.0273 21.7062 67.4293 21.7062C64.8315 21.7062 63.0996 19.9488 63.0996 17.3545C63.0996 14.7602 64.918 13.0029 67.4293 13.0029C69.9407 13.0029 71.136 14.8609 71.4129 16.0155H69.6812C69.4041 15.2623 68.7458 14.509 67.4298 14.509C65.9575 14.509 64.8319 15.6137 64.8319 17.3541C64.8319 19.0945 65.9575 20.1997 67.4298 20.1997C68.8155 20.1997 69.4908 19.2789 69.6812 18.6098H71.4129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2798 13.1709H74.0115V18.192C74.0115 19.2798 74.8948 20.2006 76.09 20.2006C77.389 20.2006 78.3418 19.2798 78.3418 18.192V13.1709H80.0735V21.5396H78.5146L78.3413 20.7026H78.2547C78.0643 20.8866 77.8564 21.054 77.6139 21.2046C77.1981 21.4558 76.5574 21.7066 75.7433 21.7066C73.6649 21.7066 72.2793 20.3845 72.2793 18.192V13.1709H72.2798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1973 9.823H83.1024V11.5803H81.1973V9.823ZM81.2839 13.1706H83.0158V21.5393H81.2839V13.1706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2685 14.7608H83.8828V13.171H85.2685V10.8279H87.0002V13.171H88.992V14.7608H87.0002V19.5307C87.0002 19.8652 87.1736 20.0327 87.5198 20.0327H88.992V21.5392H87.1736C85.9438 21.5392 85.2685 20.8697 85.2685 19.7819V14.7608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 16.0004C22 11.0295 26.086 7 31.1256 7C36.1662 7 40.2521 11.0295 40.2517 16C40.2517 17.7606 39.7389 19.4029 38.8531 20.7897C38.6088 21.1719 38.3367 21.5346 38.0385 21.8755L31.1377 15.0701L25.2037 20.9217L24.2239 21.8879C23.9249 21.5478 23.6519 21.1856 23.4076 20.8039C22.5159 19.4144 22 17.7667 22 16.0004ZM37.8069 19.5074L37.8904 19.3427L37.8908 19.3431C38.4144 18.3132 38.691 17.157 38.691 16.0004C38.691 11.8868 35.2973 8.54006 31.1261 8.54006C26.9548 8.54006 23.5616 11.8868 23.5616 16.0004C23.5616 17.1632 23.8409 18.3243 24.3694 19.3582L24.4534 19.522L31.1377 12.93L37.8069 19.5074ZM31.126 25C33.398 25 35.4764 24.1813 37.074 22.8263V22.8259L31.1381 16.972L25.191 22.8365C26.7863 24.1858 28.854 25 31.126 25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2265_11071"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 18,
    fill: "white",
    transform: "translate(22 7)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgZircuit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/zircuit.4cc2b2f9707f7e7f051631d9409e78cd.svg";